import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { DeviceStatistic } from '@vindr/services/apis/order.api';
import { Typography, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
const { Title } = Typography;

interface Widget {
  title: string;
  newItems: number;
  arrivedItems: number;
  completedItems: number;
}

const ReceptionBlock = ({ title, newItems, arrivedItems, completedItems }: Widget) => {
  const { t } = useTranslation('Vindoc');

  return (
    <div className="flex h-full w-full min-w-40 flex-col justify-between rounded-sm bg-primary-dark p-3">
      <Title level={4} className="mb-3">
        {t(title)}
      </Title>
      <div className="text-base">
        <div className="mb-2 flex justify-between">
          <div>{t('New')}</div>
          <div className="ml-2">{newItems}</div>
        </div>
        <div className="mb-2 flex justify-between">
          <div>{t('Arrived')}</div>
          <div className="ml-2">{arrivedItems}</div>
        </div>
        <div className="flex justify-between">
          <div>{t('Completed')}</div>
          <div className="ml-2">{completedItems}</div>
        </div>
      </div>
    </div>
  );
};

const ReceptionWidget = ({
  devices,
  collapsed,
}: {
  devices: DeviceStatistic[];
  collapsed: boolean;
}) => {
  const allDevice = devices.find((it) => it?.device_name === 'All devices');
  const unknown = devices.find((it) => it?.device_name === 'Unknown');
  const filterDevices = devices.filter(
    (it) => it.device_name !== 'All devices' && it.device_name !== 'Unknown'
  );
  const sortDevices = filterDevices.sort((a, b) => {
    const compareCount =
      (a.status_count?.[ORDER_STATUS.ARRIVED] || 0) - (b.status_count?.[ORDER_STATUS.ARRIVED] || 0);

    if (compareCount === 0) return a.device_name.localeCompare(b.device_name);
    else return compareCount;
  });
  const displayDevices = [
    ...(allDevice ? [allDevice] : []),
    ...(unknown ? [unknown] : []),
    ...sortDevices,
  ];

  return (
    <div
      key={'widget'}
      className="mb-3 w-full justify-between overflow-hidden"
      style={{
        minHeight: collapsed ? '0' : '127px',
        height: 0,
        transition: 'min-height 0.25s ease-out',
        willChange: 'min-height',
      }}
    >
      <Row gutter={[6, 6]} className="flex w-full flex-nowrap items-stretch overflow-scroll">
        {displayDevices.map((it) => (
          <Col
            key={it?.device_id + it?.device_name}
            className="min-w-[20%] flex-1 max-[900px]:min-w-[25%] max-sm:min-w-[33%] max-[520px]:min-w-[50%] max-[380px]:min-w-[100%]"
          >
            <ReceptionBlock
              title={it.device_name}
              newItems={it.status_count[ORDER_STATUS.NEW] || 0}
              arrivedItems={it.status_count[ORDER_STATUS.ARRIVED] || 0}
              completedItems={it.status_count[ORDER_STATUS.COMPLETED] || 0}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ReceptionWidget;
